import { notification } from 'antd';
import { getScreens, replaceButton, saveZone } from './zoneMutations';

// Старый редактор принимает только PNG и JPEG — не расширяем список, иначе можно
// собрать зону, которую терминал не покажет
const ICON_TYPES = ['image/png', 'image/jpeg'];

// Иконка едет в конфиг зоны как base64, поэтому крупный файл раздувает саму зону
const SIZE_WARNING = 200 * 1024;

export const readIconFile = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (e) => resolve(e.target.result);
  reader.onerror = () => reject(new Error('Не удалось прочитать файл'));
  reader.readAsDataURL(file);
});

export async function attachIcon(screenId, button, file) {
  if (!file || !ICON_TYPES.includes(file.type)) {
    notification.error({ message: 'Нужен PNG или JPEG' });
    return false;
  }

  if (file.size > SIZE_WARNING) {
    notification.warning({
      message: 'Тяжёлая иконка',
      description: `${Math.round(file.size / 1024)} КБ хранятся прямо в конфиге зоны — лучше уменьшить.`,
    });
  }

  let icon;
  try {
    icon = await readIconFile(file);
  } catch (e) {
    notification.error({ message: e.message });
    return false;
  }

  return saveZone(
    replaceButton(getScreens(), screenId, { ...button, icon }),
    `Иконка кнопки «${button.name}» обновлена`,
  );
}

export async function removeIcon(screenId, button) {
  return saveZone(
    replaceButton(getScreens(), screenId, { ...button, icon: false }),
    `Иконка кнопки «${button.name}» убрана`,
  );
}
